import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { SubmissionError } from 'redux-form'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import { fetchPromoter, updatePromoter } from '../actions/promoters'
import { renderInputField, renderTextAreaField, renderSelectField } from '../utils/forms'

class PromoterEditForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { promoters, fetchPromoter, match } = this.props

    if (!promoters.promoter) {
      fetchPromoter(match.params.fullname)
    } else {
      this.setState({ loaded: true })
    }

    this.load(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.promoters.promoter) {
      this.setState({ loaded: true })
    }
  }

  load(props) {

    if (!this.state.loaded) {

      this.setState({
        loaded: true
      })
    }
  }

  submit(props) {
    const { updatePromoter, promoters } = this.props

    return updatePromoter(promoters.promoter.fullname, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { loaded } = this.state
    const { promoter, promoters, error, pristine, submitting, handleSubmit } = this.props

    if (!loaded) {
      if (promoters.error) {
        return (
          <ErrorMessage message={promoters.error.message} />
        )
      }

      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <h1>
          <span className="text-vw-dark">EDITAR </span>
          <span className="text-vw-light">PROMOTOR</span>
        </h1>
        <div className="row">
          <div className="col col-12 col-lg-4">
            <Box title="Personal" icon="user">
              <Field name="fullname"
                component={renderInputField}
                type="text"
                label="Nombre Completo" />
              <Field name="birthday"
                component={renderInputField}
                type="date"
                label="Cumpleaños" />
              <Field name="phone"
                component={renderInputField}
                type="text"
                label="Teléfono" />
            </Box>
          </div>
          <div className="col col-12 col-lg-4">
            <Box title="Acceso" icon="user">
              <Field name="email"
                type="text"
                component={renderInputField}
                label="E-mail" />
              <Field name="pass"
                type="password"
                component={renderInputField}
                label="Password" />
            </Box>
          </div>
          <div className="col col-12 col-lg-4">
            <Box title="Condiciones" icon="user">
              <Field name="password"
                component={renderInputField}
                type="text"
                label="Código Fichaje" />
              <Field name="workingday"
                type="number"
                component={renderInputField}
                label="Jornada" />
              <Field name="rest"
                component={renderSelectField}
                label="Descanso">
                <option value="">Selecciona un descanso...</option>
                <option value="0">Ninguno</option>
                <option value="30">30 min</option>
                <option value="60">1 hora</option>
              </Field>
            </Box>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <button className="btn bg-vw-light text-white mr-1 save" type="submit"
          disabled={pristine || submitting}>
          Guardar
        </button>
      </form>
    )
  }
}

PromoterEditForm = reduxForm({
  form: 'PromoterEditForm',
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/promoters`)
  }
})(PromoterEditForm)

const mapStateToProps = state => ({
  promoters: state.promoters,
  initialValues: state.promoters.promoter
})

const mapDispatchToProps = dispatch => ({
  fetchPromoter: bindActionCreators(fetchPromoter, dispatch),
  updatePromoter: bindActionCreators(updatePromoter, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(PromoterEditForm)


